<div class="thongke-diemdanh-container">
  <!-- Filter Section -->
  <div class="card mb-3 filter-card">
    <div class="card-header bg-primary text-white">
      <i class="fas fa-filter mr-2"></i>
      <strong>Bộ lọc thống kê</strong>
    </div>
    <div class="card-body">
      <div class="row align-items-end">
        <!-- Từ ngày -->
        <div class="col-md-3">
          <div class="form-group mb-0">
            <label class="control-label">
              <i class="fas fa-calendar-alt text-primary mr-1"></i>
              Từ ngày
            </label>
            <kendo-dateinput 
              tabindex="1" 
              style="width:100%;" 
              [format]="'dd/MM/yyyy'" 
              (keydown)="onKeydownEvent($event)" 
              [(value)]="TimKiems.TuNgay">
            </kendo-dateinput>
          </div>
        </div>

        <!-- Đến ngày -->
        <div class="col-md-3">
          <div class="form-group mb-0">
            <label class="control-label">
              <i class="fas fa-calendar-check text-primary mr-1"></i>
              Đến ngày
            </label>
            <kendo-dateinput 
              tabindex="2" 
              style="width:100%;" 
              [format]="'dd/MM/yyyy'" 
              (keydown)="onKeydownEvent($event)" 
              [(value)]="TimKiems.DenNgay">
            </kendo-dateinput>
          </div>
        </div>

        <!-- Search button -->
        <div class="col-md-6">
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary btn-search" (click)="search()">
              <i class="fas fa-search mr-2"></i>
              {{'Tìm kiếm' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Data Table Section -->
  <div class="card data-card">
    <div class="card-header bg-info text-white">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="fas fa-clipboard-list mr-2"></i>
          <strong>Kết quả điểm danh</strong>
        </div>
        <span class="badge badge-light">{{totalItems || 0}} bản ghi</span>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-wrapper">
        <table class="table table-hover table-sm mb-0">
          <thead class="thead-light">
            <tr>
              <th style="width:60px;text-align:center">
                <i class="fas fa-hashtag"></i> STT
              </th>
              <th style="min-width:130px">
                <i class="fas fa-calendar-day mr-1"></i>Ngày học
              </th>
              <th style="min-width:130px;text-align:center">
                <i class="fas fa-user-check mr-1"></i>Điểm danh
              </th>
              <th style="min-width:120px;text-align:center">
                <i class="fas fa-calculator mr-1"></i>Tính buổi
              </th>
              <th style="min-width:150px">
                <i class="fas fa-chalkboard-teacher mr-1"></i>Lớp học
              </th>
              <th style="min-width:200px">
                <i class="fas fa-comment-alt mr-1"></i>Lý do nghỉ
              </th>
            </tr>
            <!-- Filter Row -->
            <tr class="filter-row">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <input 
                  class="form-control form-control-sm" 
                  type="text"
                  [(ngModel)]="TimKiems.TenLop" 
                  placeholder="Tìm lớp..." 
                  (keydown)="onKeydownEvent($event)">
              </td>
              <td>
                <input 
                  class="form-control form-control-sm" 
                  type="text"
                  [(ngModel)]="TimKiems.GhiChu" 
                  placeholder="Tìm lý do..." 
                  (keydown)="onKeydownEvent($event)">
              </td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of datas" class="data-row">
              <td style="text-align:center">
                <span class="badge badge-secondary">{{u.STT}}</span>
              </td>
              <td>
                <span class="text-muted">
                  <i class="far fa-calendar mr-1"></i>
                  {{u.NgayHoc | date: 'dd/MM/yyyy'}}
                </span>
              </td>
              <td style="text-align:center">
                <span class="attendance-badge" [ngClass]="{
                  'badge-success': u.DiemDanh === 'Có mặt',
                  'badge-danger': u.DiemDanh === 'Vắng',
                  'badge-warning': u.DiemDanh === 'Muộn'
                }">
                  <i class="fas" [ngClass]="{
                    'fa-check': u.DiemDanh === 'Có mặt',
                    'fa-times': u.DiemDanh === 'Vắng',
                    'fa-clock': u.DiemDanh === 'Muộn'
                  }"></i>
                  {{u.DiemDanh}}
                </span>
              </td>
              <td style="text-align:center">
                <span class="session-badge">
                  {{u.TinhBuoi}}
                </span>
              </td>
              <td>
                <strong>{{u.Lop}}</strong>
              </td>
              <td>
                <span class="text-muted">{{u.GhiChu}}</span>
              </td>
            </tr>
            <tr *ngIf="!datas || datas.length === 0">
              <td colspan="6" class="text-center text-muted py-4">
                <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                Không có dữ liệu điểm danh
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="modal-footer border-top bg-light">
  <div class="d-flex justify-content-between align-items-center w-100">
    <!-- Pagination -->
    <div class="pagination-wrapper" *ngIf="totalItems >= 10">
      <ul class="pagination mb-0">
        <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
          <a class="page-link" (click)="setPage(1)"><<</a>
        </li>
        <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
          <a class="page-link" (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li class="page-item" *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a class="page-link" (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
          <a class="page-link" (click)="setPage(currentPage + 1)">></a>
        </li>
        <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
          <a class="page-link" (click)="setPage(totalPages)">>></a>
        </li>
        <li class="page-item">
          <input 
            type="number" 
            class="form-control form-control-sm page-size-input" 
            [(ngModel)]="pageSize" 
            (blur)="search1()" />
        </li>
        <li class="page-item">
          <span class="page-link total-info">
            <strong>Tổng: {{totalItems | number}}</strong>
          </span>
        </li>
      </ul>
    </div>

    <!-- Close Button -->
    <div>
      <button class="btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát">
        <i class="fas fa-times mr-1"></i>
        Đóng lại
      </button>
    </div>
  </div>
</div>








